<template>
  <div class="news-detail-page">
    <headerView :seletedindex="seletedindex" />

    <!-- 装饰性标题区 -->
    <div class="detail-hero">
      <div class="detail-hero-inner">
        <div class="detail-hero-decor"></div>
        <h1 class="detail-hero-title">{{ newdetails.title || '加载中…' }}</h1>
        <div v-if="newdetails.addTime" class="detail-hero-meta">
          <span class="meta-pill">
            <i class="el-icon-time"></i>
            <span>{{ newdetails.addTime }}</span>
          </span>
          <span v-if="newdetails.click !== undefined" class="meta-pill">
            <i class="el-icon-view"></i>
            <span>阅读 {{ newdetails.click }}</span>
          </span>
          <span v-if="currentCategoryName" class="meta-pill meta-pill--accent">
            <i class="el-icon-collection-tag"></i>
            <span>{{ currentCategoryName }}</span>
          </span>
        </div>
      </div>
    </div>

    <div class="page-container">
      <!-- 面包屑导航 -->
      <div class="news_details_breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/newsInformation' }">新闻动态</el-breadcrumb-item>
          <el-breadcrumb-item>{{ newdetails.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button class="back-btn" size="small" plain @click="goBack">
          <i class="el-icon-back"></i>
          <span>返回列表</span>
        </el-button>
      </div>

      <div class="content-wrapper">
        <!-- 左侧新闻内容 -->
        <div class="new_details_content">
          <article class="article-card">
            <header class="article-header">
              <div v-if="currentCategoryName" class="article-category">
                {{ currentCategoryName }}
              </div>
              <h2 class="article-title">{{ newdetails.title }}</h2>
              <div class="article-meta">
                <span class="meta-item" v-if="newdetails.addTime">
                  <i class="el-icon-time"></i>
                  <span>{{ newdetails.addTime }}</span>
                </span>
                <span class="meta-divider" v-if="newdetails.click !== undefined"></span>
                <span class="meta-item" v-if="newdetails.click !== undefined">
                  <i class="el-icon-view"></i>
                  <span>阅读 {{ newdetails.click }}</span>
                </span>
              </div>
              <div class="article-divider"></div>
            </header>

            <div v-if="newdetails.summary" class="article-summary">
              <i class="el-icon-document"></i>
              <p>{{ newdetails.summary }}</p>
            </div>

            <div class="container article-body" v-html="newdetails.content"></div>

            <footer class="article-footer">
              <div class="footer-tags">
                <span class="footer-tag-label">标签：</span>
                <span
                  v-for="(tag, idx) in articleTags"
                  :key="idx"
                  class="footer-tag"
                >{{ tag }}</span>
              </div>
              <div class="footer-share">
                <span class="footer-share-label">分享：</span>
                <span class="share-icon" @click="copyLink" title="复制链接"><i class="el-icon-link"></i></span>
              </div>
            </footer>
          </article>
        </div>

        <!-- 右侧侧边栏 -->
        <aside class="sidebar">
          <!-- 新闻分类 -->
          <div class="sidebar-section">
            <h3 class="sidebar-title">
              <i class="el-icon-collection"></i>
              <span>新闻分类</span>
            </h3>
            <div class="sidebar-divider"></div>
            <ul class="category-list">
              <li
                v-for="(category, index) in newsCategories"
                :key="index"
                class="category-item"
                @click="goToCategory(category.id)"
              >
                <span class="category-name">{{ category.title }}</span>
                <span class="category-count">{{ category.count }}</span>
              </li>
              <li v-if="!newsCategories.length" class="category-empty">
                暂无分类
              </li>
            </ul>
          </div>

          <!-- 阅读排行 -->
          <div class="sidebar-section">
            <h3 class="sidebar-title">
              <i class="el-icon-trophy"></i>
              <span>阅读排行</span>
            </h3>
            <div class="sidebar-divider"></div>
            <ul class="ranking-list">
              <li
                v-for="(item, index) in readingRankings"
                :key="index"
                class="ranking-item"
                @click="viewRankingDetails(item.id, item.linkUrl, index)"
              >
                <div
                  class="ranking-number"
                  :class="{
                    'ranking-number--gold': index === 0,
                    'ranking-number--silver': index === 1,
                    'ranking-number--bronze': index === 2,
                  }"
                >{{ index + 1 }}</div>
                <div class="ranking-content">
                  <div class="ranking-title">{{ item.title }}</div>
                  <div class="ranking-reads">
                    <span class="read-dot"></span>
                    <span>{{ item.click }}次阅读</span>
                  </div>
                </div>
              </li>
              <li v-if="!readingRankings.length" class="ranking-empty">
                暂无排行
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </div>

    <footerView></footerView>
  </div>
</template>
<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import {
  getNewsDetails,
  proxy,
  getNewsType,
  Getnews,
  changeBrowsingFrequency,
} from "@/api/index";
import { timeformat } from "@/utils/timeformat";

export default {
  components: { headerView, footerView },
  data() {
    return {
      seletedindex: 4,
      newstitle: "",
      newid: 0,
      gzhHTML: "",
      newdetails: {},
      newsCategories: [],
      readingRankings: [],
    };
  },
  computed: {
    // 当前新闻所属分类名
    currentCategoryName() {
      const catId = this.newdetails && this.newdetails.categoryId;
      if (catId === undefined || catId === null) return '';
      const found = this.newsCategories.find((c) => String(c.id) === String(catId));
      return found ? found.title : '';
    },
    // 从标题或内容里提取一些关键词当作标签（兜底逻辑，避免空数据）
    articleTags() {
      const tags = [];
      if (this.currentCategoryName) tags.push(this.currentCategoryName);
      const title = (this.newdetails && this.newdetails.title) || '';
      if (title && tags.length < 3) tags.push('新闻');
      return tags.slice(0, 3);
    },
  },
  created() {
    this.$nextTick(() => {
      this.newid = this.$route.params.id;
      console.log(this.$route.params.id);
      this.getDetails();
      this.getNewsCategories();
      this.getReadingRankings();
    });
  },
  watch: {
    // 监听路由参数变化，当点击阅读排行的文章时更新详情
    "$route.params.id"(newId) {
      if (newId) {
        this.newid = newId;
        this.getDetails();
      }
    },
  },
  methods: {
    async getDetails() {
      const typenews = await getNewsDetails("/api/zaoying/news/detail", {
        id: this.newid,
      });
      if (typenews) {
        typenews.addTime = timeformat(typenews.addTime);
        this.newdetails = typenews;
      }
    },
    async getNewsCategories() {
      const categories = await getNewsType("/api/zaoying/newsCategories");
      if (categories && categories.length > 0) {
        const categoriesWithCount = await Promise.all(
          categories.map(async (category) => {
            const news = await Getnews("/api/zaoying/news", {
              category_id: category.id,
              pageNumber: 1,
              pageSize: 1,
            });
            return {
              id: category.id,
              title: category.title,
              count: news ? news.totalRecords : 0,
            };
          })
        );
        this.newsCategories = categoriesWithCount;
      }
    },
    async getReadingRankings() {
      const news = await Getnews("/api/zaoying/news", {
        category_id: "",
        pageNumber: 1,
        pageSize: 100,
      });
      if (news && news.items.length > 0) {
        const sortedNews = news.items
          .map((item) => ({
            id: item.id,
            title: item.title,
            click: item.click,
            linkUrl: item.linkUrl,
          }))
          .sort((a, b) => b.click - a.click)
          .slice(0, 5);
        this.readingRankings = sortedNews;
      }
    },
    async viewRankingDetails(id, url, index) {
      const res = await changeBrowsingFrequency("api/zaoying/browse", {
        id: id,
      });
      this.readingRankings[index].click += 1;
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$router.push({
          name: "newsDetail",
          params: {
            id: id,
          },
        });
      }
    },
    goToCategory(categoryId) {
      this.$router.push({
        name: "newsInformation",
        query: {
          categoryId: categoryId,
        },
      });
    },
    goBack() {
      // SPA 内 history.length 恒为 1，靠它判断不可靠。
      // 用 document.referrer 判断是否来自同站：来自同站则后退，否则跳到新闻列表
      const referrer = document.referrer || '';
      const currentOrigin = window.location.origin;
      let fromSameOrigin = false;
      try {
        fromSameOrigin = referrer && new URL(referrer).origin === currentOrigin;
      } catch (e) {
        fromSameOrigin = false;
      }
      // 同时排除 referrer 是当前详情页本身的边界情况
      if (fromSameOrigin && !referrer.includes(`/newsDetail/${this.newid}`)) {
        this.$router.back();
      } else {
        this.$router.push({ name: "newsInformation" });
      }
    },
    copyLink() {
      const link = window.location.href;

      const tryCopy = (text) => {
        // 方案一：现代 Clipboard API（优先）
        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(text).then(() => true).catch(() => false);
        }
        // 方案二：Safari / 旧浏览器的 execCommand 兜底
        const ta = document.createElement("textarea");
        ta.value = text;
        ta.style.cssText = "position:fixed;top:-9999px;left:-9999px;opacity:0;";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        let ok = false;
        try {
          ok = document.execCommand("copy");
        } catch (e) {
          ok = false;
        }
        document.body.removeChild(ta);
        return Promise.resolve(ok);
      };

      tryCopy(link).then((ok) => {
        if (ok) {
          this.$message.success("链接已复制，去分享给朋友吧~");
        } else {
          // 终极兜底：把链接弹出来让用户手动复制
          this.$prompt("", "请手动复制以下链接", {
            inputValue: link,
            confirmButtonText: "已复制",
            cancelButtonText: "取消",
            inputPlaceholder: link,
          });
        }
      });
    },
  },
};
</script>
<style scoped>
/* ---------- 基础 ---------- */
.news-detail-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f7f9fc 0%, #ffffff 320px);
  color: #1f2937;
}

/* ---------- Hero 装饰头部 ---------- */
.detail-hero {
  position: relative;
  background:
    radial-gradient(circle at 15% 0%, rgba(64, 158, 255, 0.18), transparent 55%),
    radial-gradient(circle at 90% 30%, rgba(22, 77, 142, 0.18), transparent 50%),
    linear-gradient(135deg, #164d8e 0%, #2a6fbe 60%, #409eff 100%);
  color: #fff;
  overflow: hidden;
}

.detail-hero::before,
.detail-hero::after {
  content: "";
  position: absolute;
  border-radius: 50%;
  filter: blur(40px);
  pointer-events: none;
}

.detail-hero::before {
  width: 320px;
  height: 320px;
  background: rgba(255, 255, 255, 0.18);
  top: -120px;
  left: -100px;
}

.detail-hero::after {
  width: 260px;
  height: 260px;
  background: rgba(255, 255, 255, 0.12);
  bottom: -100px;
  right: -80px;
}

.detail-hero-inner {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 70px 20px 60px;
  text-align: center;
}

.detail-hero-decor {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 22px;
  font-size: 13px;
  letter-spacing: 4px;
  color: rgba(255, 255, 255, 0.85);
  text-transform: uppercase;
}

.detail-hero-decor::before,
.detail-hero-decor::after {
  content: "";
  width: 28px;
  height: 1px;
  background: rgba(255, 255, 255, 0.6);
}

.detail-hero-title {
  font-size: 32px;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 auto 22px;
  max-width: 880px;
  color: #fff;
  text-shadow: 0 2px 14px rgba(0, 0, 0, 0.18);
}

.detail-hero-meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.meta-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  font-size: 13px;
  color: #fff;
  backdrop-filter: blur(8px);
}

.meta-pill--accent {
  background: #fff;
  color: #164d8e;
  font-weight: 600;
}

/* ---------- 容器 ---------- */
.page-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 28px 20px 60px;
}

.news_details_breadcrumb {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 22px;
  font-size: 13px;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* ---------- 主体两栏 ---------- */
.content-wrapper {
  display: flex;
  gap: 30px;
  justify-content: center;
  align-items: flex-start;
}

.new_details_content {
  flex: 1;
  min-width: 0;
  max-width: 800px;
}

/* ---------- 文章卡片 ---------- */
.article-card {
  background: #fff;
  border-radius: 14px;
  padding: 44px 50px;
  box-shadow: 0 8px 30px rgba(15, 31, 60, 0.06);
  border: 1px solid #eef2f7;
  position: relative;
  overflow: hidden;
}

.article-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, #164d8e, #409eff);
}

.article-header {
  margin-bottom: 28px;
}

.article-category {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 999px;
  background: rgba(22, 77, 142, 0.08);
  color: #164d8e;
  font-size: 12px;
  letter-spacing: 1px;
  margin-bottom: 14px;
  font-weight: 600;
}

.article-title {
  font-size: 30px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.4;
  margin: 0 0 18px;
  letter-spacing: 0.5px;
}

.article-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: #6b7280;
}

.meta-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.meta-divider {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #d1d5db;
}

.article-divider {
  height: 1px;
  margin-top: 22px;
  background: linear-gradient(90deg, transparent, #e5e7eb 30%, #e5e7eb 70%, transparent);
}

/* ---------- 文章摘要 ---------- */
.article-summary {
  display: flex;
  gap: 12px;
  padding: 18px 22px;
  margin: 0 0 26px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.08), rgba(22, 77, 142, 0.04));
  border-left: 3px solid #409eff;
  color: #374151;
}

.article-summary i {
  color: #409eff;
  font-size: 18px;
  margin-top: 2px;
}

.article-summary p {
  margin: 0;
  font-size: 14px;
  line-height: 1.85;
}

/* ---------- 文章正文 ---------- */
.article-body {
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 1.95;
  color: #374151;
}

.article-body :deep(p) {
  margin: 0 0 18px;
  font-size: 16px;
  line-height: 1.95;
  color: #374151;
}

.article-body :deep(h1),
.article-body :deep(h2),
.article-body :deep(h3),
.article-body :deep(h4) {
  color: #1f2937;
  font-weight: 600;
  margin: 32px 0 16px;
  line-height: 1.4;
}

.article-body :deep(h1) { font-size: 26px; padding-left: 12px; border-left: 4px solid #409eff; }
.article-body :deep(h2) { font-size: 22px; }
.article-body :deep(h3) { font-size: 19px; color: #164d8e; }
.article-body :deep(h4) { font-size: 17px; }

.article-body :deep(a) {
  color: #409eff;
  text-decoration: none;
  border-bottom: 1px solid rgba(64, 158, 255, 0.4);
  transition: all 0.2s;
}

.article-body :deep(a:hover) {
  color: #164d8e;
  border-bottom-color: #164d8e;
}

.article-body :deep(blockquote) {
  margin: 22px 0;
  padding: 16px 22px;
  background: #f5f7fb;
  border-left: 4px solid #409eff;
  border-radius: 0 8px 8px 0;
  color: #4b5563;
  font-style: normal;
}

.article-body :deep(ul),
.article-body :deep(ol) {
  padding-left: 24px;
  margin: 0 0 20px;
}

.article-body :deep(li) {
  margin-bottom: 8px;
  line-height: 1.85;
}

.article-body :deep(img) {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 24px auto;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.article-body :deep(video),
.article-body :deep(iframe) {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 24px auto;
  border-radius: 8px;
}

.article-body :deep(table) {
  max-width: 100%;
  overflow-x: auto;
  display: block;
  margin: 20px auto;
  border-collapse: collapse;
}

.article-body :deep(pre) {
  background: #1f2937;
  color: #e5e7eb;
  padding: 18px;
  border-radius: 8px;
  overflow-x: auto;
  line-height: 1.6;
}

.article-body :deep(code) {
  font-family: "SFMono-Regular", Consolas, Menlo, monospace;
  background: rgba(64, 158, 255, 0.1);
  color: #164d8e;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 14px;
}

.article-body :deep(pre code) {
  background: transparent;
  color: inherit;
  padding: 0;
}

/* ---------- 文末标签 + 分享 ---------- */
.article-footer {
  margin-top: 36px;
  padding-top: 22px;
  border-top: 1px dashed #e5e7eb;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.footer-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #6b7280;
}

.footer-tag-label {
  font-weight: 600;
  color: #374151;
}

.footer-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #374151;
  font-size: 12px;
  transition: all 0.2s;
  cursor: default;
}

.footer-tag:hover {
  background: #e0e7ff;
  color: #164d8e;
}

.footer-share {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #6b7280;
}

.footer-share-label {
  font-weight: 600;
  color: #374151;
}

.share-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f3f4f6;
  color: #409eff;
  cursor: pointer;
  transition: all 0.25s;
}

.share-icon:hover {
  background: #409eff;
  color: #fff;
  transform: translateY(-2px);
}

/* ---------- 侧边栏 ---------- */
.sidebar {
  width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 18px;
  position: sticky;
  top: 20px;
}

/* 通用侧边栏卡片 */
.sidebar-section {
  background-color: #fff;
  padding: 22px 22px 18px;
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(15, 31, 60, 0.06);
  border: 1px solid #eef2f7;
}

.sidebar-title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sidebar-title i {
  color: #409eff;
  font-size: 16px;
}

.sidebar-divider {
  height: 2px;
  background: linear-gradient(90deg, #c9a961, transparent);
  margin-bottom: 14px;
  border-radius: 2px;
}

/* 新闻分类 */
.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.category-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 11px 12px;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 4px;
}

.category-item:hover {
  background: rgba(64, 158, 255, 0.08);
  color: #164d8e;
  transform: translateX(2px);
}

.category-name {
  font-weight: 500;
}

.category-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
}

.category-item:hover .category-count {
  background: #409eff;
  color: #fff;
}

.category-empty,
.ranking-empty {
  padding: 14px;
  text-align: center;
  font-size: 13px;
  color: #9ca3af;
}

/* 阅读排行 */
.ranking-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ranking-item {
  display: flex;
  align-items: flex-start;
  padding: 12px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.25s;
  margin-bottom: 4px;
}

.ranking-item:hover {
  background: linear-gradient(90deg, rgba(64, 158, 255, 0.06), transparent);
  transform: translateX(2px);
}

.ranking-number {
  width: 26px;
  height: 26px;
  background: #e5e7eb;
  color: #6b7280;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  margin-right: 12px;
}

.ranking-number--gold {
  background: linear-gradient(135deg, #f5b301, #e58a00);
  color: #fff;
  box-shadow: 0 3px 8px rgba(245, 179, 1, 0.35);
}

.ranking-number--silver {
  background: linear-gradient(135deg, #c0c4cc, #909399);
  color: #fff;
}

.ranking-number--bronze {
  background: linear-gradient(135deg, #d0946a, #b87333);
  color: #fff;
}

.ranking-content {
  flex: 1;
  min-width: 0;
}

.ranking-title {
  font-size: 13px;
  color: #374151;
  line-height: 1.55;
  margin-bottom: 6px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}

.ranking-item:hover .ranking-title {
  color: #164d8e;
}

.ranking-reads {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #9ca3af;
}

.read-dot {
  width: 6px;
  height: 6px;
  background: #409eff;
  border-radius: 50%;
  margin-right: 6px;
}

/* ---------- 响应式 ---------- */
@media (max-width: 968px) {
  .detail-hero-inner {
    padding: 50px 16px 40px;
  }
  .detail-hero-title {
    font-size: 24px;
  }
  .article-card {
    padding: 28px 22px;
  }
  .article-title {
    font-size: 24px;
  }
  .content-wrapper {
    flex-direction: column;
  }
  .sidebar {
    width: 100%;
    position: static;
  }
  .news_details_breadcrumb {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}
</style>